/*
 * File: misc.js
 *
 * Desc: js for misc scripts in the theme
 *
 */
(function(Drupal) {
  Drupal.behaviors.greencollegeMisc = {
    attach(context, settings) {
      document.querySelectorAll('.copyLink-button').forEach(button => {
        button.addEventListener('click', () => {
          navigator.clipboard.writeText(window.location.href)
            .then(() => {
              button.textContent = 'Copied!';
              setTimeout(() => button.textContent = 'copyLink', 2000);
            })
            .catch(err => {
              console.error('Failed to copy: ', err);
            });
        });
      });

      // Script to change all old event payment link to new link.
      const targetHref = "https://startanevolution.ubc.ca/projects/supporting-green-college/";
      const replacementHref = "https://give.ubc.ca/projects/supporting-green-college/";
      const links = document.querySelectorAll("a");

      links.forEach(link => {
        if (link.href === targetHref) {
          link.href = replacementHref;
        }
      });
    }
  };
})(Drupal);
